const TONES = {
  green: "bg-emerald-500/10 text-emerald-300 border-emerald-500/30",
  amber: "bg-warn-500/10 text-warn-300 border-warn-500/40",
  red: "bg-rose-500/10 text-rose-300 border-rose-500/30",
  blue: "bg-blue-500/10 text-blue-300 border-blue-500/30",
  slate: "bg-slate-700/30 text-slate-300 border-slate-600/40",
};

const MAP = {
  PASS: "green", WARNING: "amber", ERROR: "red", "NOT VERIFIED": "slate",
  completed: "green", verified: "green", applied: "green", review: "blue", ready: "green", accepted: "green",
  running: "blue", queued: "blue", analyzing: "blue", awaiting_approval: "amber", pending: "slate",
  completed_with_errors: "amber", interrupted: "amber", paused_limit: "red", cancelled: "slate", rejected: "red",
  incomplete: "red", failed: "red", extraction_failed: "red", extracted: "green", stored: "slate",
  not_started: "slate", draft: "slate", outdated: "amber", validation_failed: "red", generated: "green",
};

export function StatusBadge({ status, label, testId }) {
  const tone = TONES[MAP[status] || "slate"];
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md border text-[11px] font-mono uppercase tracking-wider ${tone}`} data-testid={testId}>
      {label || String(status).replaceAll("_", " ")}
    </span>
  );
}
